import React from "react";
import "./Sidebar.css";

import LocationOnIcon from "@material-ui/icons/LocationOn";
import profile1 from "../assets/profile1.jpg";
import resume from "../assets/resume.pdf";
import { motion } from "framer-motion";
import GetAppIcon from "@material-ui/icons/GetApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";

const Sidebar = () => {
  const handelEmailMe = () => {
    window.open("mailto:bjpresswala@gmail.com");
  };
  const sidebar_variant = {
    hidden: {
      x: "-20vw",
    },
    visible: {
      x: 0,

      transition: {
        delay: 0.1,
        duration: 0.5,
        type: "spring",
      },
    },
  };
  return (
    <motion.div
      className="sidebar"
      variants={sidebar_variant}
      initial="hidden"
      animate="visible"
    >
      <img
        src={profile1}
        alt="avatar"
        id="avatar"
        className="sidebar__avatar"
      />
      <div className="sidebar__name">Burhanuddin</div>
      <div className="sidebar__item sidebar__title">MERN Stack Dev.</div>
      <a href={resume} download="resume.pdf">
        <div className="sidebar__item">
          <GetAppIcon className="sidebar__icon mr-1"></GetAppIcon>
          Download Resume
        </div>
      </a>
      <figure className="sidebar__social-icons my-2">
        <a href="https://www.instagram.com/bee.noobie/">
          <InstagramIcon className="sidebar__icon mr-2" />
          Follow Me{" "}
        </a>
        <br />
        <a href="https://www.linkedin.com/in/burhanuddin-presswala-689925201/">
          <LinkedInIcon className="sidebar__icon mr-2" />
          Connection{" "}
        </a>
        <br />
      </figure>
      <div className="sidebar__contact">
        <div className="sidebar__item">
          <a href="https://github.com/mr-burhanuddin">
            <GitHubIcon className="sidebar__icon mr-3" />
            Github
          </a>
        </div>
        <div className="sidebar__location">
          <LocationOnIcon className="sidebar__icon mr-2" />
          Nagpur, India
        </div>
        <div className="sidebar__item">bjpresswala@gmail.com</div>
      </div>
      <div className="sidebar__item sidebar__email" onClick={handelEmailMe}>
        Email Me
      </div>
    </motion.div>
  );
};

export default Sidebar;
